import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import WordInsideSortManageList from "./area/list";

function WordInsideManageSort(props: any) {
  let myProps = {
    listOpt: {},
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };

  const [listOpt, setListOpt] = useState<any>({
    s_mcomp_seq:"1",
    s_sort1_seq: "",
    s_sort2_seq: "",
  });
  const [sort1_arr, set_sort1_arr] = useState<any>([]);
  const [sort2_arr, set_sort2_arr] = useState<any>([]);

  useEffect(() => {
    get_sort_by_ajax({ s_type: "sort1" });
  }, []);

  const get_sort_by_ajax = (inData: any) => {
    let opt_obj = {
      s_type: "sort1",
      s_par_id: "word_inside_sort",
      s_par_seq: "",
      ...inData
    };

    let formJsonData = {
      s_mcomp_seq: listOpt.s_mcomp_seq,
      s_type: opt_obj.s_type,
      s_par_id: opt_obj.s_par_id,
      s_par_seq: opt_obj.s_par_seq,
      order_id: "a_order_num",
      "is_paging": "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/word/word_inside_sort/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          }
        }
      });
  };

  return (
    <div>
      <table style={{ width: "100%" }}>
        <colgroup>
          <col width={"25%"}></col>
          <col width={"25%"}></col>
        </colgroup>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>
              <div>
                <WordInsideSortManageList
                  listOpt={{
                    s_mcomp_seq:listOpt.s_mcomp_seq,
                    s_type: "sort1",
                    s_par_id:"word_inside_sort",
                    s_par_seq: "",
                  }}
                  info_arr={sort1_arr}
                  set_info_arr={set_sort1_arr}
                  list={() => {
                    get_sort_by_ajax({ s_type: "sort1", s_par_seq: "" });
                  }}
                  set_select_seq={(select_seq: any) => {
                    setListOpt({
                      ...listOpt,
                      s_sort1_seq: select_seq,
                    });
                    if (strFunc.is_empty(select_seq)) {
                      set_sort2_arr([]);
                    } else {
                      get_sort_by_ajax({ s_type: "sort2", s_par_seq: select_seq });
                    }
                  }}
                ></WordInsideSortManageList>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div>
                <WordInsideSortManageList
                  listOpt={{
                    s_mcomp_seq:listOpt.s_mcomp_seq,
                    s_type: "sort2",
                    s_par_id:"word_inside_sort",
                    s_par_seq: listOpt.s_sort1_seq,
                  }}
                  info_arr={sort2_arr}
                  set_info_arr={set_sort2_arr}
                  list={() => {
                    get_sort_by_ajax({ s_type: "sort2", s_par_seq: listOpt.s_sort1_seq });
                  }}
                  set_select_seq={(select_seq: any) => {
                    setListOpt({
                      ...listOpt,
                      s_sort2_seq: select_seq,
                    });
                  }}
                ></WordInsideSortManageList>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default WordInsideManageSort;